module.exports = __webpack_public_path__ + "pause-circle-outline-big.png?9045376b271ae3c668bfb023714b8b50";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pause-circle-outline-big.png
// module id = 883
// module chunks = 0